/**
 *
 * LoginPendingTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.majorelleBlueDark};
    background: ${COLORS.majorelleBlueLight};
    border-color: ${COLORS.majorelleBlueDark};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.majorelleBlueDark};
    }
  }
`;

function LoginPendingTag(props) {
  return <StyledTag label="Pending" {...props} />;
}

export default memo(LoginPendingTag);
